module.exports = __webpack_public_path__ + "static/media/campeonato_03.6959ef7f.jpg";